<iframe #iframeEle [src]="blobUrl | sanitize"></iframe>